import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { Card } from 'primereact/card';
import './styles.css';
import { ErrorMessage, Formik, Form as FormFormik, Field } from 'formik';
import * as yup from 'yup';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { insereAceite } from '../../services/assinaturas/index';
import FundoAmarelo from '../../assets/fundo_amarelo.png';

const header = <img alt="Card" src={FundoAmarelo} />;
const AceiEl = props => {
    const inscricao = props.inscricao.toString();
    const { email } = props;
    const { celular } = props;
    const { tipoCob } = props;
    const [loading, setLoading] = useState('loading');
    const [envio, setEnvio] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [warn, setWarn] = useState(false);

    const validations = yup.object().shape({
        EmailEnvio: yup.string().email('Email não é válido'),
        TelefoneEnvio: yup.string().min(11, 'whatsapp precisa ter mais de 11 caracteres.')
    });

    const initialValues = {
        FormaEnvio: '',
        TipoAceite: ''
    };

    const handleSubmit = (values, onSubmitOptions) => {
        setLoading('nada');
        values.Inscricao = inscricao;
        values.TipoAceite = envio;
        values.FormaEnvio = tipo;
        values.EmailEnvio = email;
        values.TelefoneEnvio = celular;

        if (!envio || !tipo) {
            setWarn(true);
        }

        insereAceite(values)
            .then(response => {
                if (response.status === 400) {
                    setLoading('loading');
                    setErro(true);
                } else if (response.status === 422) {
                    setLoading('loading');
                    setErro(true);
                } else if (response.status === 500) {
                    setLoading('loading');
                    setErro(true);
                } else if (response.message === 'sucessufuly') {
                    setSucesso(true);
                    setLoading('loading');
                } else {
                    setLoading('loading');
                    setErro(true);
                }
            })
            .catch(() => {
                setLoading('loading');
                setErro(true);
            });
    };

    return (
        <Popup
            modal
            trigger={<Button type="submit" label="Aceite Eletrônico" />}
        >
            {close => (
                <div className="modal">
                    <div className="content">
                        <Card className='tratar-scroll-card' header={header} title="Aceite do contrato">
                            {loading === 'loading' ? (
                                <Formik
                                    onSubmit={handleSubmit}
                                    initialValues={initialValues}
                                    validationSchema={validations}
                                >
                                    {({
                                        handleBlur,
                                        handleChange,
                                        handleSubmit,
                                        values
                                    }) => (
                                        <FormFormik className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                            <div className=" p-col-6 p-md-6">
                                                {sucesso && (
                                                    <Message
                                                        severity="success"
                                                        text="Aceite enviado"
                                                    />
                                                )}
                                                {erro && (
                                                    <Message
                                                        severity="error"
                                                        text="Ops, não conseguimos Enviar "
                                                    />
                                                )}
                                                {warn && (
                                                    <Message
                                                        severity="warn"
                                                        text="Verifique se as opções forma de envio e Tipo de envio estão marcadas "
                                                    />
                                                )}
                                            </div>

                                            <Fieldset legend="Envio">
                                                <div className="p-field p-grid">
                                                    <div>
                                                        <h2 className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                                            Tipo de Envio
                                                        </h2>
                                                        <>
                                                            <div className="p-field-checkbox p-col-4 p-md-4 p-lg-3 p-sm-3">
                                                                <Field
                                                                    as={
                                                                        RadioButton
                                                                    }
                                                                    inputId="aceite"
                                                                    name="aceite"
                                                                    value={1}
                                                                    onChange={e =>
                                                                        setEnvio(
                                                                            e.value
                                                                        )
                                                                    }
                                                                    checked={
                                                                        envio ===
                                                                        1
                                                                    }
                                                                />
                                                                <label htmlFor="aceite">
                                                                    Aceite
                                                                </label>
                                                            </div>
                                                            <div className="p-field-checkbox p-col-4 p-md-4 p-lg-4 p-sm-4">
                                                                <Field
                                                                    as={
                                                                        RadioButton
                                                                    }
                                                                    inputId="adesao"
                                                                    name="adesao"
                                                                    value={2}
                                                                    onChange={e =>
                                                                        setEnvio(
                                                                            e.value
                                                                        )
                                                                    }
                                                                    checked={
                                                                        envio ===
                                                                        2
                                                                    }
                                                                />
                                                                <label htmlFor="adesao">
                                                                    Aceite e
                                                                    adesão
                                                                </label>
                                                            </div>
                                                            <div className="p-field-checkbox p-col-4 p-md-4 p-lg-4 p-sm-4">
                                                                <Field
                                                                    as={
                                                                        RadioButton
                                                                    }
                                                                    inputId="recorrencia"
                                                                    name="recorrencia"
                                                                    value={3}
                                                                    onChange={e =>
                                                                        setEnvio(
                                                                            e.value
                                                                        )
                                                                    }
                                                                    checked={
                                                                        envio ===
                                                                        3
                                                                    }
                                                                />
                                                                <label htmlFor="recorrencia">
                                                                    Aceite,
                                                                    adesão e
                                                                    recorrência
                                                                </label>
                                                            </div>
                                                        </>
                                                    </div>
                                                    <h2 className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                                        Forma de Envio
                                                    </h2>
                                                    <div className="p-field-checkbox p-col-12 p-md-12 p-lg-3 p-sm-3">
                                                        <Field
                                                            as={RadioButton}
                                                            inputId="tipoEmail"
                                                            name="tipoEmail"
                                                            value={2}
                                                            onChange={e =>
                                                                setTipo(e.value)
                                                            }
                                                            checked={tipo === 2}
                                                        />
                                                        <label htmlFor="tipoEmail">
                                                            Email
                                                        </label>
                                                    </div>
                                                    <div className="p-field-checkbox p-col-12 p-md-12 p-lg-4 p-sm-4">
                                                        <Field
                                                            as={RadioButton}
                                                            inputId="tipoWhats"
                                                            name="tipoWhats"
                                                            value={3}
                                                            onChange={e =>
                                                                setTipo(e.value)
                                                            }
                                                            checked={tipo === 3}
                                                        />
                                                        <label htmlFor="tipoWhats">
                                                            Whatsapp
                                                        </label>
                                                    </div>
                                                    <div className="p-field-checkbox p-col-12 p-md-12 p-lg-5 p-sm-5">
                                                        <Field
                                                            as={RadioButton}
                                                            inputId="tipoMsg"
                                                            name="tipoMsg"
                                                            value={1}
                                                            onChange={e =>
                                                                setTipo(e.value)
                                                            }
                                                            checked={tipo === 1}
                                                        />
                                                        <label htmlFor="tipoMsg">
                                                            Mensagem de texto
                                                        </label>
                                                    </div>
                                                </div>
                                                <br />
                                                <div className="p-grid p-fluid ">
                                                    <div className="p-col-12 p-md-8">
                                                        <Field
                                                            value={email}
                                                            as={InputText}
                                                            name="EmailEnvio"
                                                            id="EmailEnvio"
                                                            placeholder="Email"

                                                        />
                                                        <ErrorMessage
                                                            component="span"
                                                            name="EmailEnvio"
                                                            style={{
                                                                color: 'red'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="p-col-12 p-md-8">
                                                        <Field
                                                            type="text"
                                                            value={celular}
                                                            as={InputText}
                                                            name="TelefoneEnvio"
                                                            id="TelefoneEnvio"
                                                            placeholder="Numero Whatsapp ou para Msg11"

                                                        />
                                                        <ErrorMessage
                                                            component="span"
                                                            name="TelefoneEnvio"
                                                            style={{
                                                                color: 'red'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </Fieldset>
                                            <br />
                                            <br />
                                            <div className="p-grid p-fluid">
                                                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                                    <button
                                                        type="submit"
                                                        icon="pi pi-plus"
                                                        className="btn-primary"
                                                        onClick={handleSubmit}
                                                    >
                                                        Enviar
                                                    </button>
                                                </div>
                                                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                                    <Button
                                                        type="submit"
                                                        label="Fechar"
                                                        onClick={close}
                                                    />
                                                    <br />
                                                    <br />
                                                </div>
                                            </div>
                                        </FormFormik>
                                    )}
                                </Formik>
                            ) : (
                                <div className={loading}>
                                    <ProgressSpinner
                                        style={{
                                            width: '100px',
                                            height: '100px'
                                        }}
                                        strokeWidth="1"
                                        fill="#EEEEEE"
                                        animationDuration=".5s"
                                    />
                                </div>
                            )}
                        </Card>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default AceiEl;
